export enum AppErrorType{
    Default,
    Alert,
}